module.exports = __webpack_public_path__ + "img/nav-brush-icon.a0e77548.svg";